import { API_BASE, parseJsonOrThrow } from "./base";

interface NurseSignupBody {
  email: string;
  npi: string;
  password: string;
  phone?: string;
}

interface NurseSignupResponse {
  status: "pending_approval";
  username: string;
}

interface AcceptInviteBody {
  token: string;
  password: string;
}

interface PasswordResetConfirmBody {
  token: string;
  newPassword: string;
}

/**
 * Public, unauthenticated signup calls — `apiClient(idToken)` in
 * api/client.ts can't be used here since there's no token yet at signup
 * time. Same `parseJsonOrThrow`/`API_BASE` primitives as everything else,
 * just without the `Authorization` header.
 */
export function signupNurse(body: NurseSignupBody): Promise<NurseSignupResponse> {
  return fetch(`${API_BASE}/signup/nurse`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  }).then((res) => parseJsonOrThrow(res) as Promise<NurseSignupResponse>);
}

export function acceptInvite(body: AcceptInviteBody): Promise<{ activated: true }> {
  return fetch(`${API_BASE}/invite/accept`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  }).then((res) => parseJsonOrThrow(res) as Promise<{ activated: true }>);
}

export function confirmPasswordReset(
  body: PasswordResetConfirmBody,
): Promise<{ reset: true }> {
  return fetch(`${API_BASE}/password-reset/confirm`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  }).then((res) => parseJsonOrThrow(res) as Promise<{ reset: true }>);
}
